import {linear} from './linear';

export const easyInOut = (timeFraction: number, timingFunction = linear) => {
    if (timeFraction < .5) {
        return timingFunction(2 * timeFraction) / 2;
    } else {
        return (2 - timingFunction(2 * (1 - timeFraction))) / 2;
    }
};
